<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Maintainence Management </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>Maintainence List  </h6>
      <div class="container-fluid ">

      <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">


                  <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">

                      <tbody >


                        <tr>
                            <td class="width-custom2"><b>Supplier </b></td>
                           <td>Boeing</td>
                          </tr>
                          <tr>
                            <td><b>Model & Series  </b></td>
                           <td>737-8</td>
                          </tr>
                          <tr>
                            <td><b>Aircraft Number </b></td>
                           <td>1K016</td>
                          </tr>

                          <tr>
                            <td><b>Aircraft Serial Number   </b></td>
                           <td>44304</td>
                          </tr>
                          <tr>
                            <td><b>Line Number  </b></td>
                           <td>4488</td>
                          </tr>
                        <tr>
                          <td><b>Engine Serial Number 1 </b></td>
                         <td></td>
                        </tr>
                        <tr>
                          <td><b>Engine Serial Number 2 </b></td>
                         <td></td>
                        </tr>
                        <tr>
                          <td><b>APU Serial Number</b></td>
                         <td></td>
                        </tr>
                        <tr>
                          <td><b>Landing Serial Number </b></td>
                         <td></td>
                        </tr>




                      </tbody>


                    </table>

                    <div >
 <div class="d-flex align-items-center">
  <!-- Tabs -->
    <b-col style="margin-left: -10px;" cols="12" md="" class="">
      <b-button @click="tab1()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
        Detailed Specification
      </b-button>
      <b-button @click="tab2()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
       ARL
      </b-button>
      <b-button @click="tab3()" variant="primary" size="sm" class=" bdr-rad me-1 mb-1">
    Airworthiness Directive
      </b-button>
      <b-button @click="tab4()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
   MPD 01-01-2024
      </b-button>
      <b-button @click="tab5()" variant="outline-primary" size="sm" class=" bdr-rad me-1 mb-1">
    MPD 15-9-2024
      </b-button>
     
    </b-col>

  <!-- Advanced Search tab aligned to the right -->
  <div class=" ms-auto">

      <button class="btn btn-outline-primary btn-sm mb-1 mt-0 bdr-rad" @click="tab6()">Advanced Search</button>

  </div>
</div>




          </div>


          <div class="mt-1 ms-1"  v-for="pdffile in pdffiles" :key="pdffile.id">
            <a @click="loadsavefile(pdffile.id)"  class="mb-1 mt-0 link_a">
            {{ pdffile.file_name }}
          </a>
          </div>

              </div>
              </div>



        <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">
          <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input id="filter-input" class="bdr-rad " v-model="filter" @input="loadMiinventory()" type="search" placeholder="Search">
              </b-form-input>
            </b-input-group>

          



            <div style="margin-top: 11px;" class="ms-2">
              <span class="custom-breadcrumb"><b>Showing {{totalRows}} items.</b></span>
            </div>


          </div>


          <div class="d-grid gap-2 d-md-flex justify-content-md-end">

          <div>

            </div>
          </div>
        </div>
<ul class="nav nav-tabs">
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section1()">Section 1</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link " @click="section2()">Section 2</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link active point top-bdr-rad" @click="section3()">Section 3</a>
    </li>
    <li class="nav-item nav-item2">
      <a class="nav-link nav_link" @click="section4()">Section 4</a>
    </li>
  </ul>
        <div class="card bdr-rad2 mt-1 shadow p-2 ">
          <div class="card-body mb-4">
            <div class="d-flex justify-content-center" v-if="isLoading">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else>
              <div class="table-responsive ">
                <b-table
                responsive
                style="font-size: small;"
                class="table-hover"
                :items="all_datas"
                :fields="fields"
                :current-page="currentPage"
                head-variant="dark"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                show-empty
                small
              >
              <template #thead-top>
                  <tr>
                    <th colspan="6" class="text-center font-weight-bold text-uppercase" style="background-color: #e6f2ff; border-bottom: 1px solid #000;">
                      SECTION 3: THE FOLLOWING FAA APPLIANCE AIRWORTHINESS DIRECTIVES ARE “APPLICABLE” AND IN COMPLIANCE BASED ON THE INCORPORATION OF SUPPLIER ENGINEERING CHANGES.
                    </th>
                  </tr>
              </template>




              <template #head(ad_number)="data">
<div class="d-flex flex-column">
  <span>AD Number Effective Date</span>
  <b-form-input
    v-model="columnFilters.ad_number"
    placeholder="Search"
    size="sm"
    class="mt-1"
     @input="loadMiinventory()"
  />
</div>
</template>

<template #head(amendment)="data">
<div class="d-flex flex-column">
  <span>Amendment</span>
  <b-form-input
    v-model="columnFilters.amendment"
    placeholder="Search"
    size="sm"
    class="mt-1"
     @input="loadMiinventory()"
  />
</div>
</template>

<template #head(assigned)="data">
<div class="d-flex flex-column">
  <span>Assigned to</span>
  <b-form-input
    v-model="columnFilters.assigned"
    placeholder="Search"
    size="sm"
    class="mt-1"
     @input="loadMiinventory()"
  />
</div>
</template>

<template #head(subject)="data">
<div class="d-flex flex-column">
  <span>Subject</span>
  <b-form-input
    v-model="columnFilters.subject"
    placeholder="Search"
    size="sm"
    class="mt-1"
     @input="loadMiinventory()"
  />
</div>
</template>

<template #head(compliance)="data">
<div class="d-flex flex-column">
  <span>Compliance/Limitations</span>
  <b-form-input
    v-model="columnFilters.compliance"
    placeholder="Search"
    size="sm"
    class="mt-1"
     @input="loadMiinventory()"
  />
</div>
</template>

<template #head(additional_information)="data">
<div class="d-flex flex-column">
  <span>Follow-on Action / Additional Information</span>
  <b-form-input
    v-model="columnFilters.additional_information"
    placeholder="Search"
    size="sm"
    class="mt-1"
     @input="loadMiinventory()"
  />
</div>
</template>




    <!-- <template #cell(C_name)="row">
      {{ row.value.first }} {{ row.value.last }}
    </template> -->

    <template #cell(actions)="row">

      <!-- <b-button style="background-color: rgb(71, 144, 255);"  size="sm"  class="mr-1 custom-btn">
        View
      </b-button> -->
      <!-- @mouseenter="info(row.item.idCustomer)" -->

      <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor" @click="moreinfo(row.item.idProduct)">View</a>
    <a class="dropdown-item mouse-cursor"  @click="Update(row.item.idProduct)">Update</a>

  </div>
</div>
    </template>

    <template #cell(number)="row">
                 {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }}
                  </template>
    <template #cell(P_code1)="row">
     <a href="/" > {{ row.item.P_code }}</a>
</template>


  </b-table>

  <!-- <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
      <b-pagination
    @change="pageChanged"
    v-model="currentPage"
    pills
    :total-rows="totalRows"
    :per-page="perPage"
    size="sm">
  </b-pagination>
  </b-col> -->
              </div>
            </div>
          </div>
        </div>
        <br><br>
      </div>

    </div>

    <content-footer></content-footer>
  </div>
</template>


  <script>

 import axios from 'axios';
 import authService from '@/auth.service';
 import TopNavbar from './../../layout/TopNavbar.vue';
 import ContentFooter from './../../layout/ContentFooter.vue'
import DatePicker from 'vue2-datepicker';
 import 'vue2-datepicker/index.css';



  export default {
    components :{

        TopNavbar,
        ContentFooter,
        DatePicker,

    },

      mounted(){
    this.loadMiinventory()
     this.loaddata()
      },

      computed: {




      },

      data() {
    return {
      currentPage: 1,
      mcustomers:[],
      pdffiles:[],
      all_datas:[],
    search: "",
    access_token:authService.isLoggedIn(),
      userid:authService.isUserid(),
      permissions:authService.isPermission(),
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      columnFilters: {
    ad_number: '',
    amendment: '',
    assigned: '',
    subject: '',
    compliance: '',
    additional_information: ''
  },
        FromDate: null,
        ToDate: null,
      filterOn: [],
      totalRows: '',

      perPage:15,
      pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],

      fields: [
      //   { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
        { key: 'ad_number', label: 'AD Number Effective Date', sortable: true,  },
        { key: 'amendment', label: 'Amendment', sortable: true  },
        { key: 'assigned', label: 'Assigned to', sortable: true  },
        { key: 'subject', label: 'Subject', sortable: true  },
        { key: 'compliance', label: 'Compliance/Limitations', sortable: true  },
        { key: 'additional_information', label: 'Follow-on Action / additional information', sortable: true  },
      //   { key: 'status', label: 'Status', sortable: true ,  },
      //   { key: 'created_date', label: 'Created Date', sortable: true ,  },


      //   { key: 'actions', label: 'Actions', class:'width-custom3', }
      ],

      infoModal: {
        id: 'info-modal',
        title: '',
        content: {},
      },
      isLoading: true,


    };
    },








     methods:{





async loaddata() {

            console.log(this.rows);

      try {
       // this.isLoading = true;
        const { data } = await axios.post('/mproduct/pdffilenameload',{

          headers: {
            'Authorization': 'Bearer ' + this.access_token,
            'Content-type': 'application/json',
          }
        });
        console.log(data);
        if(data.status==200){
this.pdffiles = data.pdffile
        }



        // this.isLoading = false;
      } catch (error) {
        console.log(error.response);
      }
    },
  async loadsavefile(id){
      this.$router.push('/Pdf/indexload?id='+id);

    },







    async info(idCustomer) {
  console.log(idCustomer);
  try {
    const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
      headers:{
        'Authorization':'Bearer '+this.access_token,
        'Content-type': 'application/json',

      }
     });
     console.log(data);
     this.infoModal.content = data.item_list
     this.$root.$emit('bv::show::modal', this.infoModal.id)


  } catch (error) {
    console.log(error.response);
  }
},
  async moreinfo(idproduct) {

this.$router.push('/mproduct/view?id='+idproduct);

},
async productCreate() {

this.$router.push('/pdf/create');

},
async section4() {

this.$router.push('/pdf/indextab2');

},
  async tab2(){
      this.$router.push('/Pdfarl/indextab1');
    },
async section1() {

this.$router.push('/pdf/index');

},
async section2() {

this.$router.push('/pdf/indextab2');

},
async section3() {

this.$router.push('/pdf/indextab3');

},
async section4() {

this.$router.push('/pdf/indextab4');

},
async tab3(){
      this.$router.push('/pdf/index');
    },
  async tab4(){
      this.$router.push('/Pdfmdpjan/index');
    },

    async tab5(){
      this.$router.push('/Pdfmdpsep/index');
    },

    async tab6(){
      this.$router.push('/Pdf/indexsearch');
    },


    // onFiltered(filteredItems) {
    //     // Trigger pagination to update the number of buttons/pages due to filtering
    //     this.totalRows = filteredItems.length
    //     console.log(totalRows);
    //     this.currentPage = 1
    //   },

      async loadMiinventory(page = this.currentPage) {
        // const storedPermissions = this.permissions;
        // const permissionsArray = JSON.parse(storedPermissions);
        // console.log(permissionsArray);
         console.log("aaaaaaaddd");


      try {
        const { data} = await  axios.get('/mproduct/indexpdftab3',{

          params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            columnFilters: this.columnFilters,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',

          }
         });
         console.log(data);
         this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;

      } catch (error) {
        console.log(error.response);
      }
    },

    pageChanged(page) {
      console.log(page);
     this.loadMiinventory(page);
 },











  }



  };

  </script>

  <style >


  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }
  .manage-boder{
      border-bottom: 2px solid #007bff;
      border-top: 2px solid #007bff;
      padding-bottom: 10px !important;
      padding-top: 10px !important;

      }
  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #E9E9E3;
      border-top: 2px solid #E9E9E3;
      padding-bottom: 10px !important;
      padding-top: 10px !important;

      }
      .font1{
        font-size: 13px !important;

      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;

      }
      .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
    .width7{
      width: 250px;
    }
    .bg-mycoolor{
      background-color: #a4d2f3 !important;

    }

  .modal-footer{
    text-align: right !important;
    display: block;
  }

  .pfimg3 {
  padding-left: 10px;
}
.decoration {
  text-decoration: none;
}
.width-custom3 {
  width: 180px;
}
.date-placeholder {
  position: absolute;
  top: 5px;
  left: 12px;
  pointer-events: none;
  color: #6c757d;
}



  </style>
